import requests from "./httpService";

const FaqServices = {

    AddFaq : async (body) =>{
        return requests.post(`/faq`,body);
    },

    AddFaqCategory : async (body) =>{                                                                                                       
        return requests.post(`/faqcategory`,body);
    },
    getAllFaqLanguage : async (language) =>{
        return requests.get(`/faq/language/${language}`);
    },
    getCategoryByFaq : async (categoryId, language) =>{
        return requests.post(`/faq/category/${categoryId}`, { language });
    },
    getAllFaqCategory : async () =>{
        return requests.get(`/faqcategory`);
    },
    
    UpdateFaqCategory : async (id,body) =>{
        return requests.patch(`/faqcategory/${id}`,body);
    },
    deleteFaqCategory : async (id) =>{
        return requests.delete(`/faqcategory/${id}`);
    },

    getAllFaq : async () =>{
        return requests.get(`/faq`);
    },
    getAllFaqByCategory : async (categoryId) =>{
        return requests.get(`/faq/category/${categoryId}`);
    },


    updateFaq : async (id,body) =>{
        return requests.patch(`/faq/${id}`,body);
    },
    deleteFaq : async (id) =>{
        return requests.delete(`/faq/${id}`);
    }
}

export default FaqServices;

// import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSearch, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
// import useAsync from "../hooks/useAsync";
// import FaqServices from "../services/FaqServices";
// import DeleteButton from "./Button/DeleteButton";
// import Modal from "react-modal";
// import ReactPaginate from "react-paginate";
// import Pagetitle from "./PageTitle";
// import * as XLSX from "xlsx";
// import { Link } from "react-router-dom";

// Modal.setAppElement("#root");

// function FaqList() {
//   const { data, error, isLoading, run } = useAsync(FaqServices.getAllFaqLanguage);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");

//   const [activeIndex, setActiveIndex] = useState(null);
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [selectedEdit, setSelectedEdit] = useState(null);
//   const [userTypeFilter, setUserTypeFilter] = useState("");
//   const [planFilter, setPlanFilter] = useState("");

//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredData, setFilteredData] = useState(data?.data || []);

//   const usersPerPage = 10;
//   const handleViewDetails = (user) => {
//     setSelectedUser(user);
//     setIsModalOpen(true);
//   };

//   const handleEditDetails = (help) => {
//     setSelectedEdit(help);
//     setIsEditModalOpen(true);
//     toggleActionMenu(null);
//   };

//   const handleDelete = (help) => {
//     setSelectedEdit(help);
//     setIsDeleteModalOpen(true);
//     toggleActionMenu(null);
//   };

//   const closeEditModal = () => {
//     setIsEditModalOpen(false);
//     setSelectedEdit(null);
//   };
//   const toggleActionMenu = (index) => {
//     setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
//   };
//   const closeDeleteModal = () => {
//     setIsDeleteModalOpen(false);
//     setSelectedEdit(null);
//   };

//   // Define closeModal function for closing the ViewUser modal
//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedUser(null);
//   };

//   const handlePageClick = (data) => {
//     setCurrentPage(data.selected + 1);
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) {
//       return "Invalid Date";
//     }
//     const day = date.getDate().toString().padStart(2, "0");
//     const month = (date.getMonth() + 1).toString().padStart(2, "0");
//     const year = date.getFullYear().toString();
//     return `${day}-${month}-${year}`;
//   };

//   const filteredUsers = data?.data?.filter((user) => {
//     return user?.name?.toLowerCase().includes(searchQuery?.toLowerCase() || "");
//   });

//   // Calculate pagination values
//   const indexOfLastUser = currentPage * usersPerPage;
//   const indexOfFirstUser = indexOfLastUser - usersPerPage;
//   const paginatedUsers = filteredUsers?.slice(
//     indexOfFirstUser,
//     indexOfLastUser
//   ); // Slice the filtered users for pagination

//   const [language, setLanguage] = useState("English");
//   const [activeTab, setActiveTab] = useState("ALL");

//   const handleLanguageChange = (lang) => setLanguage(lang);
//   const handleTabChange = (tab) => setActiveTab(tab);

//   return (
//     <div className="right_col" role="main">
//       <Pagetitle />
//       <div className="container-box user-manager">
//         <div className="language-btn d-flex px-4" style={{ gap: '20px', marginBottom: '70px' }}>
//           <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
//                 <li className="nav-item" role="presentation">
//                     <button className="nav-link active" id="pills-english-tab" data-bs-toggle="pill" data-bs-target="#pills-english" type="button" role="tab" aria-controls="pills-english" aria-selected="true">English</button>
//                 </li>
//                 <li className="nav-item" role="presentation">
//                     <button className="nav-link" id="pills-hindi-tab" data-bs-toggle="pill" data-bs-target="#pills-hindi" type="button" role="tab" aria-controls="pills-hindi" aria-selected="false">Hindi</button>
//                 </li>
//             </ul>
//             <Link className="Add-new-btn site-btn-green ms-auto" to="/add-faq">
//                 <img src="img/add-plus.svg" alt="" />
//                 <span className="ms-2">Add New</span>
//               </Link>
//         </div>
//         <div className="tab-content px-4" id="pills-tabContent">
//             <div className="tab-pane fade show active" id="pills-english" role="tabpanel" aria-labelledby="pills-english-tab">
//                 <div className="container-box-inner">
//                     <div className="container-box-top-subheading">
//                         <p>Frequently Asked Questions</p>
//                     </div>
//                     <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link active" id="pills-reedem-tab" data-bs-toggle="pill" data-bs-target="#pills-reedem" type="button" role="tab" aria-controls="pills-reedem" aria-selected="true">ALL</button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link" id="pills-wallet-tab" data-bs-toggle="pill" data-bs-target="#pills-wallet" type="button" role="tab" aria-controls="pills-wallet" aria-selected="false">COTTAGE</button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link" id="pills-scan-tab" data-bs-toggle="pill" data-bs-target="#pills-scan" type="button" role="tab" aria-controls="pills-scan" aria-selected="false">BOOKING</button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link" id="pills-videos-tab" data-bs-toggle="pill" data-bs-target="#pills-videos" type="button" role="tab" aria-controls="pills-videos" aria-selected="false">CANCEL</button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link" id="pills-videos-tab" data-bs-toggle="pill" data-bs-target="#pills-videos" type="button" role="tab" aria-controls="pills-videos" aria-selected="false">OFFER</button>
//                         </li>
//                     </ul>
//                     <div className="tab-content" id="pills-tabContent">
//                         <div className="tab-pane fade show active" id="pills-reedem" role="tabpanel" aria-labelledby="pills-reedem-tab">
//                             <div className="faq-outer">
//                                 <div className="accordion" id="accordionExample">
//                                     <div className="accordion-item-outer">
//                                         <div className="accordion-item">
//                                             <h2 className="accordion-header" id="headingOne">
//                                                 <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
//                                                     <span className="qustn">Q :</span> <span>When I will pay for the products ?</span>
//                                                 </button>
//                                             </h2>
//                                             <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
//                                                 <div className="accordion-body">
//                                                     <div className="faq-answer-inside">
//                                                         <p>Answer :</p>
//                                                         <p>Delivering the best in class, innovative product range from almost 4 decades now, our position in the lighting industry is indisputably unshakable.</p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="faq-edit-grp">
//                                             <a className="video-edit-btn" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#editModal">
//                                                 <i className="fa fa-pencil"></i>
//                                             </a>
//                                             <a className="video-edit-btn" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#deleteModal" style={{ backgroundColor: '#FB0000' }}>
//                                                 <i className="fa fa-trash"></i>
//                                             </a>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         {/* Repeat similar structure for other tabs */}
//                     </div>
//                 </div>
//             </div>
//             <div className="tab-pane fade" id="pills-hindi" role="tabpanel" aria-labelledby="pills-hindi-tab">
//                 <div className="container-box-inner">
//                     <div className="container-box-top-subheading">
//                         <p>Frequently Asked Questions</p>
//                     </div>
//                     <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link active" id="pills-reedem-tab" data-bs-toggle="pill" data-bs-target="#pills-reedem" type="button" role="tab" aria-controls="pills-reedem" aria-selected="true">ALL</button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link" id="pills-wallet-tab" data-bs-toggle="pill" data-bs-target="#pills-wallet" type="button" role="tab" aria-controls="pills-wallet" aria-selected="false">COTTAGE</button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link" id="pills-scan-tab" data-bs-toggle="pill" data-bs-target="#pills-scan" type="button" role="tab" aria-controls="pills-scan" aria-selected="false">BOOKING</button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link" id="pills-videos-tab" data-bs-toggle="pill" data-bs-target="#pills-videos" type="button" role="tab" aria-controls="pills-videos" aria-selected="false">CANCEL</button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link" id="pills-videos-tab" data-bs-toggle="pill" data-bs-target="#pills-videos" type="button" role="tab" aria-controls="pills-videos" aria-selected="false">OFFER</button>
//                         </li>
//                     </ul>
//                     <div className="tab-content" id="pills-tabContent">
//                         <div className="tab-pane fade show active" id="pills-reedem" role="tabpanel" aria-labelledby="pills-reedem-tab">
//                             <div className="faq-outer">
//                                 <div className="accordion" id="accordionExample">
//                                     <div className="accordion-item-outer">
//                                         <div className="accordion-item">
//                                             <h2 className="accordion-header" id="headingOne">
//                                                 <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
//                                                     <span className="qustn">Q :</span> <span>When I will pay for the products ?</span>
//                                                 </button>
//                                             </h2>
//                                             <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
//                                                 <div className="accordion-body">
//                                                     <div className="faq-answer-inside">
//                                                         <p>Answer :</p>
//                                                         <p>Delivering the best in class, innovative product range from almost 4 decades now, our position in the lighting industry is indisputably unshakable.</p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="faq-edit-grp">
//                                             <a className="video-edit-btn" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#editModal">
//                                                 <i className="fa fa-pencil"></i>
//                                             </a>
//                                             <a className="video-edit-btn" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#deleteModal" style={{ backgroundColor: '#FB0000' }}>
//                                                 <i className="fa fa-trash"></i>
//                                             </a>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         {/* Repeat similar structure for other tabs */}
//                     </div>
//                 </div>
//             </div>
//           </div>
//       </div>
//       <Modal
//         isOpen={isDeleteModalOpen}
//         onRequestClose={closeDeleteModal}
//         contentLabel="Delete Confirmation"
//         className="modal-content"
//         overlayClassName="modal-overlay"
//       >
//         <DeleteButton
//           data={selectedEdit}
//           page="User"
//           closeModal={closeDeleteModal}
//           onSuccess={run}
//         />
//       </Modal>
//     </div>
//   );
// }

// export default FaqList;
